export default "__VITE_ASSET__Yhu6DMrM__"